import {
  AppBar,
  Box,
  Container,
  IconButton,
  Toolbar,
  useMediaQuery,
} from '@mui/material'
import { Outlet } from 'react-router-dom'
import {
  useAppSettings,
  useCartButton,
  useCurrentStore,
  useCurrentUser,
  useRedirectToHomePage,
} from 'hooks'
import { useTheme } from '@mui/material/styles'
import { MainLogo } from 'components/images'
import { CartButton } from 'components/ordering/CartButton'
import { AvatarButton } from 'components/appbar/AvatarButton'
import HomeIcon from '@mui/icons-material/Home'
import { isEmpty } from 'lodash'
import { FullScreenLoading } from 'components/core/FullScreenLoading'
import { SearchHandler } from 'components/search/SearchHandler'

export const MainLayout = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { isLoading } = useCurrentUser()
  const { isCartButtonVisible } = useCartButton()
  const redirectToHomePage = useRedirectToHomePage()
  const { store } = useCurrentStore()

  const handleLogoClick = () => {
    redirectToHomePage()
  }

  const { appSettings } = useAppSettings()
  const handleHomeClick = () => {
    window.location.href = appSettings?.home
  }

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minWidth: theme.custom.contentMinWidth,
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <AppBar
        position="static"
        sx={{
          boxShadow: theme.custom.shadows[0],
          background: theme.palette.common.white,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            disableGutters
            sx={{ gap: 3, justifyContent: 'space-between' }}
          >
            {!isEmpty(appSettings?.home) ? (
              <IconButton color="primary" onClick={handleHomeClick}>
                <HomeIcon fontSize="large" />
              </IconButton>
            ) : (
              <MainLogo width={84} onClick={handleLogoClick} />
            )}
            {isCartButtonVisible && (
              <>
                {isMobile && <Box sx={{ flexGrow: 1 }} />}
                <SearchHandler />
                <CartButton />
              </>
            )}
            {store?.is_show_auth && <AvatarButton />}
          </Toolbar>
        </Container>
      </AppBar>
      <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <Outlet />
      </Box>
    </Box>
  )
}
